import { Box, Typography } from '@mui/material';
import React from 'react';

import { Colors } from '../../../../../design/color/Colors';
import { IUnitCardModel } from '../../../../../../service/unit/interface/IUnitCardModel';
import { IPassingListPageDomain } from '../../store/IPassingListPageDomain';

interface Props {
  title: string;
  unitList: IUnitCardModel[];
  domain: IPassingListPageDomain;
}

export const GroupCardComponentList = ({ title, domain, unitList }: Props) => {
  if (!unitList.length) {
    return null;
  }

  return (
    <Box>
      <Typography variant="overline" sx={{ color: Colors.textSecondary, letterSpacing: '1.5px' }}>
        {title}
      </Typography>
    </Box>
  );
};
